import { render } from "./ViewCVModal.vue?vue&type=template&id=10fdfa1c&scoped=true"
import script from "./ViewCVModal.vue?vue&type=script&lang=js"
export * from "./ViewCVModal.vue?vue&type=script&lang=js"

import "./ViewCVModal.vue?vue&type=style&index=0&id=10fdfa1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fdfa1c"]])

export default __exports__